@if (formField(); as field) {
  <app-input-address [(value)]="value" />
}
